<template>
  <v-card id="promotion-list">
    <!-- search -->
    <v-card-text class="d-flex align-center flex-wrap pb-0">
      <div class="d-flex align-center pb-5">

        <v-btn
          color="primary"
          class="me-3"
          @click="createDialogShow()"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiPlus }}
          </v-icon>
          <span>Добавить</span>
        </v-btn>
      </div>

      <v-spacer></v-spacer>

      <div class="d-flex align-center pb-5">
        <v-text-field
          v-model="filters.searchQuery"
          single-line
          dense
          outlined
          hide-details
          placeholder="Поиск..."
          class="promotion-list-search me-3"
        ></v-text-field>
      </div>
    </v-card-text>

    <!-- table -->
    <v-data-table
      :headers="headers"
      :items="crmSettings"
      :server-items-length="totalCount"
      :loading="loading"
      :page.sync="filters.pageNumber"
      :items-per-page.sync="filters.pageSize"
      :sort-by.sync="filters.sortBy"
      :sort-desc.sync="filters.sortDesc"
      class="text-no-wrap"
    >

      <template #[`item.host`]="{item}">
        {{ item.host }}
      </template>

      <template #[`item.port`]="{item}">
        {{ item.port }}
      </template>

      <template #[`item.globalType`]="{item}">
        {{ item.globalType }}
      </template>

      <template #[`item.terminalType`]="{item}">
        {{ item.terminalType }}
      </template>

      <!-- actions -->
      <template #[`item.actions`]="{item}">
        <div class="d-flex align-center justify-center">

          <!-- edit -->
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-bind="attrs"
                v-on="on"
                @click="updateDialogShow(item.id)"
              >
                <v-icon size="18">
                  {{ icons.mdiPencilOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Редактирование</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <crm-settings-form :label="'Редактирование настроек CRM'" :cancellation="updateDialogCancel" :show="updateDialog"
                      :save="updateApplicationDescription"></crm-settings-form>
    <crm-settings-form :label="'Создание настроек CRM'" :cancellation="createDialogCancel" :show="createDialog"
                      :save="addApplicationDescription"></crm-settings-form>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import CrmSettingsForm from './crm-settings-form.vue'
import {
  mdiTrendingUp,
  mdiPlus,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiEyeOutline,
  mdiPencilOutline,
} from '@mdi/js'

export default {
  components: { CrmSettingsForm },
  name: 'CrmSettingsList',
  data: () => ({
    createDialog: false,
    updateDialog: false,
    icons: {
      mdiTrendingUp,
      mdiPlus,
      mdiPencilOutline,
      mdiDeleteOutline,
      mdiDotsVertical,
      mdiEyeOutline,
    },
    deleteMethod: null,
  }),
  computed: {
    ...mapFormHandlers('crmSettings', [
      'filters.pageNumber',
      'filters.pageSize',
      'filters.searchQuery',
      'filters.sortBy',
      'filters.sortDesc',
    ]),
    ...mapState('crmSettings', {
      crmSettings: 'list',
      totalCount: 'totalCount',
      loading: 'loading',
    }),
    headers() {
      return [
        { text: 'GlobalType', value: 'globalType' },
        { text: 'Порт', value: 'port' },
        { text: 'Адрес', value: 'host' },
        { text: 'Тип терминала', value: 'terminalType' },
        {
          text: 'Действия',
          value: 'actions',
          align: 'center',
          sortable: false,
        },
      ]
    },
  },
  async created() {
    this.fetchRk7Settings()
  },
  mounted() {
  },
  methods: {
    ...mapActions('crmSettings', {
      fetchRk7Settings: 'fetchList',
    }),
    ...mapActions('crmSettings/form', ['create', 'resetForm', 'fetchById', 'update']),
    async addApplicationDescription() {
      await this.create()
      this.createDialog = false
    },
    async updateApplicationDescription() {
      await this.update()
      this.updateDialog = false
    },
    createDialogShow() {
      this.createDialog = true
    },
    createDialogCancel(){
      this.createDialog = false
    },
    updateDialogCancel() {
      this.updateDialog = false
    },
    updateDialogShow(id) {
      this.fetchById(id)
      this.updateDialog = true
    },
  },
}
</script>

<style lang="scss" scoped>
#promotion-list {
  .promotion-list-search {
    max-width: 10.625rem;
  }
}
</style>
